import { z } from "zod";

export const ROLES = ["owner", "beheerder", "inspecteur", "uitvoerder", "klant"] as const;
export const roleSchema = z.enum(ROLES);
export type Role = z.infer<typeof roleSchema>;

export const ROLE_LABELS: Record<Role, string> = {
  owner: "Eigenaar",
  beheerder: "Beheerder",
  inspecteur: "Inspecteur",
  uitvoerder: "Uitvoerder",
  klant: "Klant",
};

export const ISSUE_STATUSES = ["open", "noodreparatie", "in_opdracht", "opgelost", "gesloten"] as const;
export type IssueStatus = (typeof ISSUE_STATUSES)[number];
export const STATUS = [
  { k: "open", l: "Open" },
  { k: "noodreparatie", l: "Noodreparatie gedaan" },
  { k: "in_opdracht", l: "In opdracht" },
  { k: "opgelost", l: "Opgelost" },
  { k: "gesloten", l: "Gesloten" },
] as const satisfies readonly { k: IssueStatus; l: string }[];
/** Status "Actief" = Open, Noodreparatie gedaan, In opdracht (er moet nog iets gebeuren). */
export const ACTIVE_STATUSES: ReadonlySet<IssueStatus> = new Set(["open", "noodreparatie", "in_opdracht"]);
export const statusLabel = (k: string): string => STATUS.find((s) => s.k === k)?.l ?? k;
/** Statuskleuren voor licht papier (PDF-rapport); in de app via CSS-tokens `--st-*`. */
export const STATUS_HEX: Record<IssueStatus, string> = {
  open: "#1F6FC4",
  noodreparatie: "#B86E00",
  in_opdracht: "#0D7268",
  opgelost: "#17804A",
  gesloten: "#5B6670",
};

export const PRIORITIES = ["P1", "P2", "P3", "P4"] as const;
export type Priority = (typeof PRIORITIES)[number];
export const PRIO: Record<Priority, { l: string; t: string }> = {
  P1: { l: "Spoed", t: "binnen 4 uur" },
  P2: { l: "Hoog", t: "binnen 24 uur" },
  P3: { l: "Normaal", t: "binnen 5 werkdagen" },
  P4: { l: "Laag", t: "inplannen bij volgende ronde" },
};

export const TASK_STATUSES = ["open", "bezig", "klaar"] as const;
export type TaskStatus = (typeof TASK_STATUSES)[number];

export const FILE_KINDS = ["plan", "photo", "report", "attachment", "document"] as const;
export const ISSUE_EVENT_KINDS = [
  "created",
  "comment",
  "status",
  "priority",
  "location",
  "task",
  "robaws",
  "photo",
  "edit",
  "system",
] as const;
export const ROBAWS_KINDS = ["order", "offer", "workorder"] as const;
export type RobawsKind = (typeof ROBAWS_KINDS)[number];

/** Soorten bijlagen bij een asset. */
/** Soorten bijlagen bij een asset. */
export const ASSET_FILE_KINDS = ["document", "drawing", "manual"] as const;
export type AssetFileKind = (typeof ASSET_FILE_KINDS)[number];
/** Alles wat aan een asset hangt: foto's (herkenning) en bijlagen. */
export const ASSET_LINK_KINDS = ["photo", ...ASSET_FILE_KINDS] as const;
export type AssetLinkKind = (typeof ASSET_LINK_KINDS)[number];
export const ASSET_FILE_KIND_LABELS: Record<AssetFileKind, string> = {
  document: "Documenten",
  drawing: "Tekeningen",
  manual: "Handleidingen",
};
